import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHand} from "@fortawesome/free-solid-svg-icons";
import React from "react";

export const NoPermissionView = () => (
  <div
    className={"flex flex-1 flex-col justify-center items-center border-gray-100 border-2 h-[calc(100%)] gap-y-6"}
  >
    <FontAwesomeIcon icon={faHand} className={"text-9xl text-gray-300"} />
    <div className={"text-3xl text-gray-500"}>
      您沒有權限瀏覽此頁面
    </div>
  </div>
)